/* unplugin-vue-components disabled */import { render } from "./DownloadTickets.vue?vue&type=template&id=02865335&scoped=true&ts=true"
import script from "./DownloadTickets.vue?vue&type=script&lang=ts"
export * from "./DownloadTickets.vue?vue&type=script&lang=ts"

import "./DownloadTickets.vue?vue&type=style&index=0&id=02865335&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02865335"]])

export default __exports__